'use client';

import ErrorBoundary from '@/commons/ErrorBoundary';

interface GlobalErrorProps {
  readonly error: Error & {digest?: string};
  readonly reset: () => void;
}

export default function GlobalError({error}: GlobalErrorProps) {
  const formattedError = JSON.stringify(
    {
      error: {message: error.message, stack: error.stack},
    },
    undefined,
    2,
  );

  return (
    <html lang="en">
      <body>
        <ErrorBoundary error={formattedError} />
      </body>
    </html>
  );
}
